<template>
    <div class="premium_label">
        <b-icon icon="star-fill"/>&nbsp;{{ $t("premium") }}
    </div>
</template>

<script>
export default {
    name: "premium-label",
};
</script>

<style scoped lang="scss">
@use "@/scss/custom";
.premium_label {
    color: custom.$color-orange;
    font-family: custom.$monospace-font-family;
    font-size: 11px;
    padding-left: 7px;
    padding-right: 7px;
    padding-top: 3px;
    padding-bottom: 3px;
    display: inline-block;
    border: solid 1px custom.$color-orange;
    border-radius: 5px;
    background-color: white;
}
</style>
